<div class="tw-mb-1.5 tw-flex tw-flex-wrap tw-gap-1 tw-text-left">
  @for (
    item of !shouldShowMore() ? items().slice(0, threshold()) : items();
    track item
  ) {
    <span
      #chips
      tabindex="-1"
      class="tw-h-5 tw-cursor-default tw-whitespace-nowrap tw-rounded-xl tw-bg-neutral-200 tw-px-2 tw-py-0.5 tw-text-xs"
    >
      {{ item }}
    </span>
  }
</div>
@if (items().length > threshold() && !shouldShowMore()) {
  <button (click)="expand()" type="button" class="tw-btn-small tw-btn-tertiary">
    {{ showMoreText() }}
  </button>
}
